import { render, staticRenderFns } from "./TournamentClubView.vue?vue&type=template&id=c38e6c62&scoped=true&"
import script from "./TournamentClubView.vue?vue&type=script&lang=js&"
export * from "./TournamentClubView.vue?vue&type=script&lang=js&"
import style0 from "./TournamentClubView.vue?vue&type=style&index=0&id=c38e6c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38e6c62",
  null
  
)

export default component.exports